import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import dwlLogo from "../images/dwl_logo_login.png";
import SharedButton from "./shared/SharedButton";
import SharedInput from "./shared/SharedInput";
import { usePasswordValidation } from "./shared/usePasswordValidation";
import { app_url, useQuery } from "./shared/Utils";

const CreatePassword = ({ showLoader }) => {
  const history = useHistory();
  let query = useQuery();
  let userId = query.get("userid");
  let token = query.get("token").toString().replace(/ /g, "+");
  const [validateToken, setValidateToken] = useState(false);
  const [password, setPassword] = useState({
    firstPassword: "",
    secondPassword: "",
  });

  const [validLength, hasNumber, upperCase, lowerCase, specialChar, match] =
    usePasswordValidation({
      firstPassword: password.firstPassword,
      secondPassword: password.secondPassword,
    });

  const setFirst = (event) => {
    setPassword({ ...password, firstPassword: event.target.value });
  };
  const setSecond = (event) => {
    setPassword({ ...password, secondPassword: event.target.value });
  };

  const gotoResetPage = () => {
    history.push("/resetpass?isInvalidLink=True");
  };

  const validateUserToken = async () => {
    if (token !== null && userId !== null) {
      showLoader(true);
      const bodyData = {
        Token: token,
        UserId: userId,
      };
      await fetch(`${app_url}account/validateresettoken`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data?.status !== "Error") {
            setValidateToken(true);
          } else {
            setValidateToken(false);
          }
          showLoader(false);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      history.push("/");
    }
  };

  const handleResetPassword = async () => {
    showLoader(true);
    const bodyData = {
      Token: token,
      UserId: userId,
      Password: password.firstPassword,
    };
    await fetch(`${app_url}account/resetpassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        showLoader(false);
        history.push("/");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    validateUserToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="login-container">
      <div id="createBox" className="login-box">
        <div className="password-reset">
          <div className="reset-logo t-center">
            <img
              src={dwlLogo}
              alt="dwl logo"
              className="img-fluid dwl-login-logo"
            />
          </div>
          {validateToken ? (
            <>
              <div className="access-box">
                <h2 className="t-center reset-text">Create Password</h2>
              </div>
              <p className="password-instuctions">
                For security purposes your password must contain:
              </p>
              <ul className="password-create-list">
                <li>
                  <i
                    className={`fa fa-check-circle ${
                      lowerCase ? "checked" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                  <p className="password-case-text">Lowercase</p>
                </li>{" "}
                <li>
                  <i
                    className={`fa fa-check-circle ${
                      upperCase ? "checked" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                  <p className="password-case-text">Uppercase</p>
                </li>{" "}
                <li>
                  <i
                    className={`fa fa-check-circle ${
                      hasNumber ? "checked" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                  <p className="password-case-text">Number</p>
                </li>{" "}
                <li>
                  <i
                    className={`fa fa-check-circle ${
                      specialChar ? "checked" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                  <p className="password-case-text">
                    Special Character{" "}
                    <span className="password-case-specialChars">
                      !@#$%^&amp;*()+=
                    </span>
                  </p>
                </li>{" "}
                <li>
                  <i
                    className={`fa fa-check-circle ${
                      validLength ? "checked" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                  <p className="password-case-text">Eight Characters Long</p>
                </li>
              </ul>
              <div className="reset-form">
                <div className="vd_input-wrapper">
                  <label htmlFor="email">Password</label>
                  <div className="input-with-icon">
                    <span className="menu-icon">
                      <i className="fa fa-lock"></i>
                    </span>
                    <SharedInput
                      id="password"
                      name="Password"
                      inputType="password"
                      inputChange={setFirst}
                      value={password.firstPassword}
                    />
                  </div>
                </div>
              </div>
              {validLength &&
              hasNumber &&
              upperCase &&
              lowerCase &&
              specialChar ? (
                <>
                  <p className="password-instuctions">
                    <strong>Great, please re-type your password</strong>
                  </p>
                  <ul className="password-create-list">
                    <li>
                      <i
                        className={`fa fa-check-circle ${
                          match ? "checked" : ""
                        }`}
                        aria-hidden="true"
                      ></i>
                      <p className="password-case-text">Password Match</p>
                    </li>{" "}
                  </ul>
                  <div className="reset-form">
                    <div className="vd_input-wrapper">
                      <label htmlFor="email"> Confirm Password</label>
                      <div className="input-with-icon">
                        <span className="menu-icon">
                          <i className="fa fa-lock"></i>
                        </span>
                        <SharedInput
                          id="confirmpassword"
                          name="Confirm Password"
                          inputType="password"
                          inputChange={setSecond}
                          value={password.secondPassword}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {match ? (
                <div className="confirm-btn t-center">
                  <SharedButton
                    id="confirm-password-btn"
                    addClass="btn-reset-link w-100 minh-34"
                    btnName="Submit"
                    handleClick={handleResetPassword}
                  />
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              <div className="access-box">
                <h2 className="t-center reset-text is-required">
                  Your Setup Link has Expired!
                </h2>
              </div>
              <div className="new-link t-center">
                <SharedButton
                  id="btn-request"
                  addClass="btn-reset-link w-100 minh-34"
                  btnName="Request a New Link"
                  handleClick={gotoResetPage}
                />
              </div>
              <p className="email-inst t-center">
                Please note that for security reasons, your personal link
                expires in 24 hours. You can always visit{" "}
                <Link to="/" className="forgot-text">
                  Market Rates
                </Link>{" "}
                and click the <strong>Forgot Password</strong> link to set up
                your account.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreatePassword;
